// LivestreamSuperChatNotice.js
'use strict';
import { connect } from 'react-redux';

import LivestreamSuperChatNotice from '../component/LivestreamSuperChatNotice.jsx';

import getListData from '../selector/getListData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

import { livestreamNoticeType } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.SUPER_CHAT_NOTICE;
  const noticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const noticeSelectPath = [streamId, noticeType, noticeIds[0]];

  return {
    noticeId: noticeIds[0],
    userId: getLiveStreamData(state, noticeSelectPath, 'userId'),
    text: getLiveStreamData(state, noticeSelectPath, 'text'),
    diamonds: getLiveStreamData(state, noticeSelectPath, 'diamonds'),
    noticeStatus: getLiveStreamData(state, noticeSelectPath, 'status'),
  };
};

export default connect(mapStateToProps)(LivestreamSuperChatNotice);
